// extracted by mini-css-extract-plugin
export default {"deviantArtIcon":"zrN3El"};